export const aiCoursesSearch = {
  "courses": [
    {
      "university_name": "University of Oxford",
      "course_name": "MBA with AI Specialization",
      "course_type": "MBA",
      "duration": "1 year",
      "tuition_fees": "£65,520",
      "living_costs": "£14,500/year",
      "location": "Oxford, UK",
      "university_type": "Public",
      "ranking": 5,
      "employability_rate": "95%",
      "visa_support": "Yes",
      "ai_courses_offered": [
        "Machine Learning",
        "AI Ethics",
        "Data Analytics"
      ],
      "ai_specializations": [
        "Financial AI",
        "AI in Healthcare"
      ],
      "career_outcomes": {
        "average_salary": "£100,000",
        "top_employers": [
          "Google",
          "McKinsey & Company",
          "Amazon"
        ],
        "job_roles": [
          "AI Consultant",
          "Data Scientist",
          "AI Strategist"
        ]
      },
      "student_satisfaction": {
        "overall_score": 90,
        "teaching_quality": 92,
        "course_content": 88,
        "facilities": 91
      },
      "research_strength": {
        "ai_research_ranking": 3,
        "publications_count": 1500,
        "research_areas": [
          "Machine Learning",
          "AI Ethics"
        ]
      },
      "entry_requirements": {
        "academic_requirements": "2:1 degree in any discipline",
        "english_requirements": "IELTS 7.0",
        "work_experience": "3+ years required"
      },
      "course_structure": {
        "modules": [
          "Introduction to AI in Business",
          "Machine Learning for Managers",
          "AI and Strategy"
        ],
        "assessment_methods": [
          "Coursework",
          "Exams",
          "Group Project"
        ],
        "practical_components": "Yes"
      },
      "score": 95,
      "evidence_sources": [
        {
          "source": "QS World University Rankings",
          "url": "https://www.topuniversities.com/universities/university-of-oxford",
          "title": "University of Oxford Ranking",
          "snippet": "Oxford University is ranked among the top universities in the world.",
          "confidence": 0.9,
          "type": "academic",
          "domain": "education"
        }
      ]
    },
    {
      "university_name": "London Business School",
      "course_name": "MBA with AI and Data Analytics",
      "course_type": "MBA",
      "duration": "15 months",
      "tuition_fees": "£92,735",
      "living_costs": "£15,000/year",
      "location": "London, UK",
      "university_type": "Private",
      "ranking": 7,
      "employability_rate": "94%",
      "visa_support": "Yes",
      "ai_courses_offered": [
        "Data Science for Business",
        "AI in Finance",
        "Machine Learning"
      ],
      "ai_specializations": [
        "Data Science",
        "AI in Healthcare"
      ],
      "career_outcomes": {
        "average_salary": "£105,000",
        "top_employers": [
          "Microsoft",
          "Goldman Sachs",
          "Facebook"
        ],
        "job_roles": [
          "AI Analyst",
          "Data Strategist",
          "Business Intelligence Developer"
        ]
      },
      "student_satisfaction": {
        "overall_score": 88,
        "teaching_quality": 90,
        "course_content": 85,
        "facilities": 89
      },
      "research_strength": {
        "ai_research_ranking": 10,
        "publications_count": 1200,
        "research_areas": [
          "Data Science",
          "AI in Finance"
        ]
      },
      "entry_requirements": {
        "academic_requirements": "2:1 degree in a related field",
        "english_requirements": "IELTS 7.5",
        "work_experience": "4+ years preferred"
      },
      "course_structure": {
        "modules": [
          "AI and Business Strategy",
          "Advanced Data Analytics",
          "Machine Learning Applications"
        ],
        "assessment_methods": [
          "Exams",
          "Coursework",
          "Capstone Project"
        ],
        "practical_components": "Yes"
      },
      "score": 92,
      "evidence_sources": [
        {
          "source": "Financial Times MBA Rankings",
          "url": "https://rankings.ft.com/businessschoolrankings/london-business-school",
          "title": "London Business School MBA Ranking",
          "snippet": "London Business School is consistently ranked among the top 10 business schools globally.",
          "confidence": 0.85,
          "type": "academic",
          "domain": "education"
        }
      ]
    }
  ],
  "search_summary": {
    "total_courses_found": 2,
    "countries_represented": [
      "UK"
    ],
    "fee_ranges": {
      "lowest": "£65,520",
      "highest": "£92,735",
      "average": "£79,128"
    },
    "experience_levels": [
      "Intermediate",
      "Advanced"
    ],
    "top_universities": [
      "University of Oxford",
      "London Business School"
    ]
  },
  "context": {
    "title": "AI Courses Search Results",
    "summary": "The search results highlight top MBA programs in the UK offering AI specializations.",
    "methodology": "Courses were selected based on rankings, AI relevance, and career outcomes.",
    "insights": [
      "Oxford and LBS offer leading AI-focused MBAs.",
      "Tuition fees range from £65,520 to £92,735.",
      "Graduates see high employability and competitive salaries."
    ],
    "citations": []
  },
  "tab_name": "ai-courses-search",
  "evidence_sources": [
    {
      "source": "QS World University Rankings",
      "url": "https://www.topuniversities.com/university-rankings/business-masters-rankings/mba/2025",
      "title": "Top MBA Programs in UK 2025 - QS World University Rankings",
      "snippet": "QS World University Rankings for MBA programs in the UK 2025, featuring top institutions like Oxford, Cambridge, and London Business School with comprehensive program details.",
      "confidence": 0.9,
      "category": "course_information",
      "content_domain": "Course Info"
    },
    {
      "source": "Financial Times",
      "url": "https://rankings.ft.com/businessschoolrankings/global-mba-ranking-2025",
      "title": "Financial Times MBA Rankings 2025 - UK Business Schools",
      "snippet": "Financial Times annual MBA rankings 2025 including UK business schools with employment rates, salary data, and career outcomes for graduates.",
      "confidence": 0.8,
      "category": "course_information",
      "content_domain": "Course Info"
    }
  ],
  "cached": false,
  "timestamp": "2025-08-29T01:23:07.738932",
  "models_used": [
    "gpt-4o-mini"
  ],
  "plan_type": "university_paid",
  "metadata": {
    "analysis_type": "ai_courses_search",
    "country": "UK",
    "total_courses": 2,
    "query": "MBA",
    "category": "Business",
    "experience_level": "",
    "budget_range": "",
    "limit": 10,
    "response_time": 12.7,
    "model_meta": {
      "model_used": "gpt-4o-mini",
      "analysis_engine": "ai_courses_search_v1",
      "web_search_used": true
    }
  }
};
